module.exports = __webpack_public_path__ + "img/UnderReview.254dd10f.svg";